/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */

// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useRef, useState } from 'react';
import { getIconPath, routerPush, getViewportInfo } from '@tcp/core/src/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getAPIConfig, isCanada } from '@tcp/core/src/utils/utils';
import { QVEcommerceCall } from '@tcp/core/src/components/features/browse/CategoryListingPage/container/analyticsHelper.js';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import { getZoneOneBadgesArray } from '@tcp/core/src/utils/badge.util';
import {
  extractAttributeValue,
  getInfluencerTags,
  getInfluencerPicks,
} from '@tcp/core/src/services/abstractors/productListing/productParser';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { globalCommonBrowseLabels } from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { globalSortingLabels } from '@tcp/core/src/utils/labels/globalSorting.labels';
import ColorSwatches from './ColorSwatches';
import getImageData from './plpTileHelpers/imageDataHelper';
import getPlpTileBadges from './plpTileHelpers/plpTileBadgesHelper';
import { getInteractiveColorSwatchesClass } from './plpTileHelpers/slpTileHelper';
import { AtbIcon } from './styles/SubmitButton.style';
import {
  extractBaseUrl,
  getImageAssetConfig,
  getPdpUrl,
  getPlpProductBrand,
  getProductDataForPdp,
  isBundleProduct,
  triggerOneClickATC,
} from './plpTileHelpers/plpTileCommonHelpers';
import PriceAndWishList from './PriceAndWishList';
import Wishlist from './Wishlist';
import Price from './Price';
import ProductImage from './ProductImage';
import ProductTitleAndBrand from './ProductTitleAndBrand';
import PromotionView from './Promotion.view';
import ZoneOneBadges from './ZoneOneBadges.view';
import { ZoneOneBadgesWrapper } from './styles/ZoneOneBadges.style';

import style, { ColorSwatchWrapper, HeroTile } from './styles/HeroTile.style';
import TopBadge from './styles/TopBadge.style';
import InfluencerBadgeHandle from '../../../../common/atoms/InfluencerBadgeHandle/view/InfluencerBadgeHandle';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import { memoizeTileData } from './plpTileHelpers/cacheHelper';
import { featureBrandTileAttribute } from '../../SearchDetail/container/SearchDetail.constants';

// eslint-disable-next-line complexity
function HeroTileView(props) {
  const globalBrowseLabels = getLabelFromCopyOrFromTranslation(
    'global.CommonBrowseLabels',
    globalCommonBrowseLabels
  );

  const bestSellerBadgeLabel = renderLabel(globalBrowseLabels.lbl_best_seller, 'lbl_best_seller');

  const sortingLabels = getLabelFromCopyOrFromTranslation('global.Sorting', globalSortingLabels);

  const topRatedBadgeLabel = renderLabel(
    sortingLabels.lbl_TCPBazaarVoiceRating,
    'lbl_TCPBazaarVoiceRating'
  );
  const mostFavoritedBadgeLabel = renderLabel(
    sortingLabels.lbl_favoritedcount,
    'lbl_favoritedcount'
  );

  const {
    className,
    pathName,
    customClass,
    tileData,
    tileActions,
    wishListData,
    isShortImage,
    promotionsData = {},
    trackClickPromotion,
    serverTime,
    isBuyMorePromoEnabled,
    isLoggedIn,
    trackWishListClick,
    saveProductDataForPdp,
    saveProductDataForQV,
    categoryName,
    isTopRatedBackAbEnabled,
    isBestSellerBackAbEnabled,
    isPaginatorClicked,
    isNewSwatchUrlEnabled,
    preloadImage,
    isBopisFilterOn,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isMostFavoritedBadgeEnabled,
    setPLPSLPAddToCartCTA,
    isInfluencerBadgeEnabled,
    isTileRedesignAB,
    isInfluencerPicksEnabled,
    favAddRemoveLoadingState,
    isAlternateImageOnHoverEnabled,
    isShowPriceRangeEnabled,
    isUpdatedPromotionsDisplayEnabled,
    onHeightChange,
    isDynamicColorSwatchesEnabled,
    isHoverToPreviewColorSwatchesEnabled,
    isInteractiveColorSwatchBandEnabled,
    isSwatchAsColorUrlEnabled,
    isFeatureBrandEnabled,
  } = props;
  const hasMounted = useHasMounted();
  const tileRef = useRef(null);

  useEffect(() => {
    if (tileRef.current) {
      const height = tileRef.current.offsetHeight;
      if (onHeightChange) {
        onHeightChange(height);
      }
    }
  }, [tileRef.current, tileData]);

  let isMountedTileRedesignAB = 'variationA';
  if (hasMounted && isTileRedesignAB === 'variationB') {
    isMountedTileRedesignAB = 'variationB';
  }
  if (hasMounted && !isTileRedesignAB) {
    isMountedTileRedesignAB = false;
  }

  const { isDesktop } = getViewportInfo() || {};
  let isMountedInteractiveColorSwatchBandEnabled = false;
  if (hasMounted && isDesktop && isInteractiveColorSwatchBandEnabled) {
    isMountedInteractiveColorSwatchBandEnabled = true;
  }

  const {
    prodpartno: productPartNo,
    style_partno: stylePartNo,
    seo_token: seoToken,
    product_name: productName,
    min_list_price: minLP,
    min_offer_price: minOP,
    low_offer_price: lowOfferPrice,
    high_offer_price: highOfferPrice,
    low_list_price: lowListPrice,
    high_list_price: highListPrice,
    TCPSwatchesUSStore,
    TCPSwatchesCanadaStore,
    productimage: imageName,
    alt_img: altImage,
    TCPStyleQTYCA,
    TCPStyleQTYUS,
    TCPStyleTypeCA,
    TCPStyleTypeUS,
    swatchimage: swatchImg,
    related_product_swatch_images: relatedSwatches,
    TCPColor: tcpColor,
    auxdescription: auxDescription,
    TCPCustomSalePrice,
    TCPCustomListPrice,
    tcp_promotion_id: TCPPromotionID,
    tcp_promo_price: TCPPromotionPrice,
  } = tileData;
  const TCPPrimaryCategory = !isCanada()
    ? extractAttributeValue(tileData, 'TCPPrimaryCategoryUSStore')
    : extractAttributeValue(tileData, 'TCPPrimaryCategoryCanadaStore');
  tileData.TCPPrimaryCategory = TCPPrimaryCategory;
  const featureBrand =
    isFeatureBrandEnabled && extractAttributeValue(tileData, featureBrandTileAttribute);
  const minListPrice = TCPCustomListPrice || minLP;
  const minOfferPrice = TCPCustomSalePrice || minOP;
  const styleTypeQty = {
    TCPStyleQTYCA,
    TCPStyleQTYUS,
    TCPStyleTypeCA,
    TCPStyleTypeUS,
  };
  const relatedSwatchImages = (relatedSwatches && relatedSwatches.split(',')) || [];
  const isHardMarkDown = tileData?.is_hard_mark_enable;
  const isHideOriginalPrice = hideProductOriginalPrice(
    isHardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  const { onQuickViewOpenClick, onAddItemToFavorites, onSetLastDeletedItemIdAction, addToBagEcom } =
    tileActions;
  const isBundle = isBundleProduct(tileData);
  const commonCacheKeys = { pathName, productId: productPartNo };
  const tileBadges = memoizeTileData(
    getPlpTileBadges,
    { ...commonCacheKeys, key: 'badges' },
    {
      tileData,
      categoryName,
      bestSellerBadgeLabel,
      topRatedBadgeLabel,
      mostFavoritedBadgeLabel,
      isBundleProduct: isBundle,
    }
  );
  const { topBadge, merchantTag, zoneOneBadges } = tileBadges;
  const apiConfig = getAPIConfig();
  const { brandId: primaryBrand, siteId } = apiConfig;
  const { pdpUrl } = getPdpUrl({
    seoToken,
    siteId,
    productPartNo,
    isBundleProduct: isBundle,
    TCPPrimaryCategory,
  });
  const TCPSwatches = siteId === 'us' ? TCPSwatchesUSStore : TCPSwatchesCanadaStore;
  const brand = memoizeTileData(
    getPlpProductBrand,
    { ...commonCacheKeys, key: 'brand' },
    tileData,
    primaryBrand
  );

  const { assetHost, assetPath } = getImageAssetConfig(brand, apiConfig);
  const assetHostBaseUrl = extractBaseUrl(assetHost);
  const influencerTags = getInfluencerTags(tileData);
  const influencerPicks = getInfluencerPicks(tileData);

  const showInfluencerPick = influencerPicks && isInfluencerPicksEnabled;
  const influencerPickToDisplay = showInfluencerPick && influencerPicks[0];

  const topRatedBadge = !isTopRatedBackAbEnabled && tileBadges?.topRatedBadge;
  const bestSellerBadge = !isBestSellerBackAbEnabled && tileBadges?.bestSellerBadge;
  const mostFavoritedBadge = !isMostFavoritedBadgeEnabled && tileBadges?.mostFavoritedBadge;

  let zoneOneBadgesArray = [];
  if (isMountedTileRedesignAB) {
    zoneOneBadgesArray = getZoneOneBadgesArray({
      zoneOneBadges,
      topRatedBadge,
      bestSellerBadge,
      mostFavoritedBadge,
      influencerPickToDisplay,
    });
  }

  const { imageUrl, itemAvailability, isVideoUrl, fullImageUrl, overlayBadgeParams } = getImageData(
    {
      stylePartNo,
      productPartNo,
      assetPath,
      imageName,
      altImage,
      isShortImage,
      primaryBrand,
      assetHostBaseUrl,
      ...styleTypeQty,
    }
  );
  const [newImageUrl, setNewImageUrl] = useState(imageUrl);

  useEffect(() => {
    setNewImageUrl(imageUrl);
  }, [imageUrl]);

  /**
   * Determines if the swatch ID is provided and if any relevant features are enabled.
   * @param {string} swatchId - The swatch ID to check.
   * @returns {boolean} - True if swatch ID is provided and any feature is enabled.
   */
  const isSwatchFeatureActive = (swatchId) => {
    const isSwatchIdPresent = Boolean(swatchId);
    const isFeatureEnabled =
      isHoverToPreviewColorSwatchesEnabled || isInteractiveColorSwatchBandEnabled;

    return isSwatchIdPresent && isFeatureEnabled;
  };

  const collectProductDataOnClick = (swatchId = '') => {
    const uniqueIdProduct = tileData?.uniqueId || '';
    const isSwatchIdProvided = isSwatchFeatureActive(swatchId);

    let updateImageURL = imageUrl;
    let updateFullImageURL = fullImageUrl;
    let stylePartNoUpdated = stylePartNo;
    if (isSwatchIdProvided) {
      stylePartNoUpdated = swatchId.split('_');
      updateImageURL = imageUrl?.replace(uniqueIdProduct, swatchId);
      updateImageURL = updateImageURL?.replace(stylePartNo, stylePartNoUpdated[0]);
      updateFullImageURL = fullImageUrl?.replace(uniqueIdProduct, swatchId);
      updateFullImageURL = updateFullImageURL?.replace(stylePartNo, stylePartNoUpdated[0]);
    }

    const updatedTileData = {
      ...tileData,
      uniqueId: isSwatchIdProvided ? swatchId : uniqueIdProduct,
      stylePartNo: isSwatchIdProvided ? stylePartNoUpdated[0] : stylePartNo,
      zoneOneBadgesArray,
    };
    return getProductDataForPdp({
      topBadge,
      styleTypeQty,
      primaryBrand: brand,
      isShortImage,
      productImageUrl: updateImageURL,
      tileData: updatedTileData,
      downloadedImage: updateFullImageURL,
      merchantTag,
      isBundle,
      promotionsData,
      TCPSwatches,
      isFromHeroProductTile: true,
    });
  };
  const setProductDataForPdp = () => {
    const pdpData = collectProductDataOnClick();
    saveProductDataForPdp(pdpData);
    pushEventToAdobeAnalytics('product_click', pdpData);
  };

  const saveDataForQv = (swatchId = '') => {
    const quickViewData = collectProductDataOnClick(swatchId);
    saveProductDataForQV(quickViewData);
  };

  const handleViewBundleClick = () => {
    const { href, asPathWithoutSlug } = pdpUrl;
    routerPush(href, asPathWithoutSlug);
  };

  const handleClick = () => {
    if (isBundle) {
      handleViewBundleClick();
      setProductDataForPdp();
    } else {
      const hasTriggeredOneClickATC = triggerOneClickATC({
        tileData,
        isOneClickATCEnabled,
        isBopisFilterOn,
        topBadge,
        brand,
        imageUrl,
        addToBagEcom,
      });
      if (!hasTriggeredOneClickATC) {
        saveDataForQv();
        onQuickViewOpenClick({
          colorProductId: productPartNo,
          fromPage: 'PLP',
        });
        QVEcommerceCall({
          tileData,
          isTopRatedBackAbEnabled,
          isBestSellerBackAbEnabled,
          tileBadges,
        });
      }
    }
  };

  const renderColorSwatches = ({ handleHoverOnColorSwatch, handleMouseLeave }) => {
    return (
      <ColorSwatches
        productPartNo={productPartNo}
        TCPSwatches={TCPSwatches}
        onQuickViewOpenClick={onQuickViewOpenClick}
        assetHost={assetHost}
        assetPath={assetPath}
        saveDataForQv={saveDataForQv}
        swatchImg={swatchImg}
        tcpColor={tcpColor}
        auxDescription={auxDescription}
        relatedSwatchImages={relatedSwatchImages}
        isBundleProduct={isBundle}
        handleViewBundleClick={handleClick}
        AddedtoBagDynamicStore={AddedtoBagDynamicStore}
        isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
        isTileRedesignAB={isMountedTileRedesignAB}
        isDynamicColorSwatchesEnabled={isDynamicColorSwatchesEnabled}
        isHoverToPreviewColorSwatchesEnabled={isHoverToPreviewColorSwatchesEnabled}
        handleMouseEnter={handleHoverOnColorSwatch}
        handleMouseLeave={handleMouseLeave}
        productStyleType={TCPStyleQTYUS || TCPStyleQTYCA}
        isSwatchAsColorUrlEnabled={isSwatchAsColorUrlEnabled}
      />
    );
  };

  const renderBadge = () => {
    if (isMountedTileRedesignAB) {
      if (zoneOneBadgesArray?.length > 0) {
        return (
          <ZoneOneBadgesWrapper>
            {zoneOneBadgesArray.map((badge) => {
              return (
                <ZoneOneBadges
                  key={badge.priority.toString()}
                  type={badge.type}
                  text={badge.label}
                />
              );
            })}
          </ZoneOneBadgesWrapper>
        );
      }
      return <ZoneOneBadgesWrapper />;
    }
    return showInfluencerPick ? (
      <TopBadge>{influencerPickToDisplay?.toUpperCase()}</TopBadge>
    ) : (
      <TopBadge>{topBadge}</TopBadge>
    );
  };

  const atbParentCls = isTileRedesignAB ? 'atb-icon-parent' : '';

  const handleHoverOnColorSwatch = (id) => {
    const imageNameExtension = imageName?.split('.')[1] || 'png';
    if (id) {
      const tempImageUrl = `${assetPath}/${id.split('_')[0]}/${id}.${imageNameExtension}`;
      setNewImageUrl(tempImageUrl);
    }
  };

  const handleMouseEnter = () => {
    if (altImage && productPartNo && isAlternateImageOnHoverEnabled) {
      const altImageParsed = JSON.parse(altImage);
      const productImage = altImageParsed[productPartNo]?.split(',')[0];

      if (productImage) {
        const tempImageUrl = `${assetPath}/${stylePartNo}/${productImage}`;
        setNewImageUrl(tempImageUrl);
      }
    }
  };

  const handleMouseLeave = () => {
    if (
      newImageUrl !== imageUrl &&
      (isAlternateImageOnHoverEnabled || isHoverToPreviewColorSwatchesEnabled)
    ) {
      setNewImageUrl(imageUrl);
    }
  };

  const tileHoverProps = isMountedInteractiveColorSwatchBandEnabled
    ? {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      }
    : {};

  const renderPromotionAndTileInfo = () => {
    return (
      <div
        className={`${isMountedInteractiveColorSwatchBandEnabled ? 'price-promotion-class' : ''}`}
      >
        {promotionsData[TCPPromotionID] && (
          <PromotionView
            promotionsData={promotionsData}
            showIcon={false}
            trackClickPromotion={trackClickPromotion}
            serverTime={serverTime}
            className={'isPLP'}
            pageName={'PLP'}
            brand={brand}
            isBuyMorePromoEnabled={isBuyMorePromoEnabled}
            isTileRedesignAB={isTileRedesignAB}
            TCPPromotionPrice={TCPPromotionPrice}
            TCPPromotionID={TCPPromotionID}
            isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
          />
        )}
        <ProductTitleAndBrand
          itemAvailability={itemAvailability}
          productName={productName}
          brand={brand}
          primaryBrand={primaryBrand}
          pdpUrl={pdpUrl}
          pathName={pathName}
          setProductDataForPdp={setProductDataForPdp}
          isTileRedesignAB={isTileRedesignAB}
          isBundle={isBundle}
          isMountedTileRedesignAB={isMountedTileRedesignAB}
          featureBrand={featureBrand}
          isHeroProduct
        />
      </div>
    );
  };

  return (
    <HeroTile
      data-prodId={productPartNo}
      className={`${className} ${customClass}`}
      ref={tileRef}
      {...tileHoverProps}
      isInteractiveColorSwatchBandEnabled={isInteractiveColorSwatchBandEnabled}
    >
      <div className={`flex-row justify-between`}>{renderBadge()}</div>
      {isPaginatorClicked ? null : (
        <div
          className={`relative${getInteractiveColorSwatchesClass(
            isMountedInteractiveColorSwatchBandEnabled
          )}`}
        >
          <ProductImage
            key={`pti-${productPartNo}`}
            itemAvailability={itemAvailability}
            fullImageUrl={fullImageUrl}
            pdpUrl={pdpUrl}
            productName={productName}
            isVideoUrl={isVideoUrl}
            pathName={pathName}
            setProductDataForPdp={setProductDataForPdp}
            imageUrl={newImageUrl}
            assetHostBaseUrl={assetHostBaseUrl}
            overlayBadgeParams={overlayBadgeParams}
            topRatedBadge={topRatedBadge}
            bestSellerBadge={bestSellerBadge}
            mostFavoritedBadge={mostFavoritedBadge}
            preloadImage={preloadImage}
            isMountedTileRedesignAB={isMountedTileRedesignAB}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            isMountedInteractiveColorSwatchBandEnabled={isMountedInteractiveColorSwatchBandEnabled}
            handleHoverOnColorSwatch={handleHoverOnColorSwatch}
            productPartNo={productPartNo}
            TCPSwatches={TCPSwatches}
            onQuickViewOpenClick={onQuickViewOpenClick}
            assetHost={assetHost}
            assetPath={assetPath}
            saveDataForQv={saveDataForQv}
            swatchImg={swatchImg}
            tcpColor={tcpColor}
            auxDescription={auxDescription}
            relatedSwatchImages={relatedSwatchImages}
            isBundleProduct={isBundle}
            handleViewBundleClick={handleClick}
            isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
            isHeroProduct
          />
          <InfluencerBadgeHandle
            isAbOn={isInfluencerBadgeEnabled}
            influencerTags={influencerTags}
            image={imageName}
            isPreviewImage
          />
          <Wishlist
            wishListData={wishListData}
            productName={productName}
            productPartNo={productPartNo}
            onAddItemToFavorites={onAddItemToFavorites}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            primaryBrand={primaryBrand}
            trackWishListClick={trackWishListClick}
            isLoggedIn={isLoggedIn}
            isBundle={isBundle}
            favAddRemoveLoadingState={favAddRemoveLoadingState}
          />
        </div>
      )}
      {hasMounted || isTileRedesignAB ? (
        <div className="product-swatch-atb">
          <div>
            {' '}
            {isMountedTileRedesignAB && !isMountedInteractiveColorSwatchBandEnabled && (
              <ColorSwatchWrapper isTileRedesignAB={isTileRedesignAB} isPlp>
                {renderColorSwatches({ handleHoverOnColorSwatch, handleMouseLeave })}
              </ColorSwatchWrapper>
            )}
            {setPLPSLPAddToCartCTA !== 'off' ? (
              <div className={`flex-row justify-between ${atbParentCls}`}>
                <Price
                  minListPrice={minListPrice}
                  minOfferPrice={minOfferPrice}
                  lowOfferPrice={lowOfferPrice}
                  highOfferPrice={highOfferPrice}
                  lowListPrice={lowListPrice}
                  highListPrice={highListPrice}
                  productPartNo={productPartNo}
                  merchantTag={merchantTag}
                  onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                  primaryBrand={primaryBrand}
                  isLoggedIn={isLoggedIn}
                  isBundle={isBundle}
                  isHideOriginalPrice={isHideOriginalPrice}
                  setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
                  isShowPriceRangeEnabled={isShowPriceRangeEnabled}
                  isTileRedesignAB={isMountedTileRedesignAB}
                  isHeroProduct
                />
              </div>
            ) : (
              <PriceAndWishList
                minListPrice={minListPrice}
                minOfferPrice={minOfferPrice}
                lowOfferPrice={lowOfferPrice}
                highOfferPrice={highOfferPrice}
                lowListPrice={lowListPrice}
                highListPrice={highListPrice}
                productPartNo={productPartNo}
                merchantTag={merchantTag}
                wishListData={wishListData}
                onAddItemToFavorites={onAddItemToFavorites}
                onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                primaryBrand={primaryBrand}
                trackWishListClick={trackWishListClick}
                isLoggedIn={isLoggedIn}
                isBundle={isBundle}
                isHideOriginalPrice={isHideOriginalPrice}
                isPLP
                isShowPriceRangeEnabled={isShowPriceRangeEnabled}
                isTileRedesignAB={isMountedTileRedesignAB}
                setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
                isHeroProduct
              />
            )}
            {isMountedInteractiveColorSwatchBandEnabled && renderPromotionAndTileInfo()}
          </div>
          <AtbIcon
            onClick={async () => {
              await AddedtoBagDynamicStore();
              handleClick();
            }}
            data-testid="atb-button"
            isHeroProduct
          >
            <img className="atb-icon-image" src={getIconPath('add-to-bag')} alt="Add to bag" />
          </AtbIcon>
        </div>
      ) : (
        <PriceAndWishList
          minListPrice={minListPrice}
          minOfferPrice={minOfferPrice}
          lowOfferPrice={lowOfferPrice}
          highOfferPrice={highOfferPrice}
          lowListPrice={lowListPrice}
          highListPrice={highListPrice}
          productPartNo={productPartNo}
          merchantTag={merchantTag}
          wishListData={wishListData}
          onAddItemToFavorites={onAddItemToFavorites}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          primaryBrand={primaryBrand}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isBundle={isBundle}
          isHideOriginalPrice={isHideOriginalPrice}
          isPLP
          isShowPriceRangeEnabled={isShowPriceRangeEnabled}
          isTileRedesignAB={isMountedTileRedesignAB}
          setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
        />
      )}
      {!isMountedInteractiveColorSwatchBandEnabled && renderPromotionAndTileInfo()}
    </HeroTile>
  );
}
export { HeroTileView as HeroTileViewVanilla };
export default withStyles(HeroTileView, style);
